import React from "react";
import "./CertificationCard.css";

const loadLogo = (name) => {
  if (!name) return null;
  try {
    return require(`../../assests/images/${name}`);
  } catch (e) {
    return null;
  }
};

// Optional fields: logo_path (falls back to the issuer's initials), certificate_link
// (card is a plain block without it), issuer and year (shown as small tags).
export default function CertificationCard({ certificate }) {
  const logo = loadLogo(certificate.logo_path);
  const link = certificate.certificate_link;
  const Tag = link ? "a" : "div";
  const linkProps = link
    ? { href: link, target: "_blank", rel: "noopener noreferrer", "aria-label": `${certificate.title} certificate` }
    : {};
  return (
    <Tag className="cert-card" {...linkProps}>
      <div className="cert-header" style={{ backgroundColor: certificate.color_code }}>
        {logo ? (
          <img className="logo_img" src={logo} alt={certificate.alt_name} />
        ) : (
          <span className="cert-initials" aria-hidden="true">
            {certificate.badge || certificate.title.slice(0, 3).toUpperCase()}
          </span>
        )}
        <span className="cert-shine" aria-hidden="true" />
      </div>
      <div className="cert-body">
        {(certificate.issuer || certificate.year) && (
          <div className="cert-tags">
            {certificate.issuer && <span className="chip">{certificate.issuer}</span>}
            {certificate.year && <span className="chip chip-mono">{certificate.year}</span>}
          </div>
        )}
        <h3 className="cert-body-title">{certificate.title}</h3>
        <p className="cert-body-subtitle">
          {(certificate.subtitle || "").replace(/^[-\s]+/, "")}
        </p>
        {link && (
          <span className="cert-link">
            View certificate <span aria-hidden="true">↗</span>
          </span>
        )}
      </div>
    </Tag>
  );
}
